<template>
  <div class="v-spinner" v-show="loading" v-if="propLoading">
    <div
      class="v-sync v-sync1"
      v-bind:style="[spinnerStyle, spinnerDelay1]"
    ></div>
    <div
      class="v-sync v-sync2"
      v-bind:style="[spinnerStyle, spinnerDelay2]"
    ></div>
    <div
      class="v-sync v-sync3"
      v-bind:style="[spinnerStyle, spinnerDelay3]"
    ></div>
  </div>
  <div id="inspire" class="fuente" style="height: 90%" v-else>
    <v-toolbar class="nav" dense>
      <v-toolbar-title class="titulo" style="color: white">
        <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        style="color: #294697"
        ></v-app-bar-nav-icon>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <Notificaciones
        @custom-click="getNotifications()"
        :notifications="notifications"
        :notification="notification"
        :messages="messages"
      ></Notificaciones>
      <v-btn
        color="#294697"
        style="color: white"
        small
        depressed
        @click="logout"
      >
        <span>Cerrar Sesión</span>
        <v-icon>mdi-power-standby</v-icon>
      </v-btn>
    </v-toolbar>

    <v-container fluid fill-height>
      <v-layout>
        <v-flex xs12 sm2 md2>
          <v-navigation-drawer
            class="drawer"
            v-model="drawer"
            :temporary="isMobileOrTablet"
            absolute
            :width="280"
            :overlay-opacity="0"
            :hide-overlay="true"
          >
            <div v-if="isMobileOrTablet" class="close-button-container">
              <v-btn
                icon
                @click="drawer = false"
                class="close-btn"
                color="white"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-img
              :src="require('../.././assets/PANTALLA-03.png')"
              contain
            >
            <div style="display: flex; justify-content: center; align-items: center; height: 250px; background-color: #294697;">
              <v-img
                class="ma-0 pa-0"
                :src="require('../.././assets/nova/NOMBREBLANCO.png')"
                max-height="100"
                contain
              ></v-img>
            </div>
            </v-img>
            <v-list dense>
              <div class="name">{{ nombre }}</div>
              <v-list-item-group color="#294697">
                <v-list-item
                  v-for="(item, i) in items"
                  :key="i"
                  :to="item.link"
                  @click="handleNavigation"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <div v-if="idCargo == 29">
                  <v-list-item
                    v-for="(item, i) in subMenu"
                    :key="i"
                    :to="item.link"
                    @click="handleNavigation"
                  >
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
                <v-list-item @click="logout">
                  <v-list-item-icon>
                    <v-icon>mdi-power-standby</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>CERRAR SESIÓN</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 sm10 md10>
          <v-main>
            <v-container style="height: 100%" transition="slide-y-transition">
              <router-view to="children" />
            </v-container>
          </v-main>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import env from "@/components/env.js";
import axios from "axios";
import Notificaciones from "@/components/Notificaciones/Notificaciones";
export default {
  name: "SyncLoader",
  components: {
    Notificaciones,
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: "#294697",
    },
    size: {
      type: String,
      default: "30px",
    },
    margin: {
      type: String,
      default: "2px",
    },
    radius: {
      type: String,
      default: "100%",
    },
  },
  data() {
    return {
      propLoading: this.loading,
      nombre: localStorage.getItem("nombre"),
      rol: localStorage.getItem("rol"),
      idCargo: localStorage.getItem("idCargo"),
      drawer: null,
      messages: 0,
      notification: false,
      notifications: [],
      items: [
        { text: "INICIO", icon: "mdi-home", link: "/User/Inicio" },
        { text: "PERFIL", icon: "mdi-account", link: "/User/Perfil" },
      ],
      subMenu: [{ text: "PANICO", icon: "mdi-alert", link: "/User/Panico" }],
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: "inline-block",
        animationName: "v-syncStretchDelay",
        animationDuration: "0.6s",
        animationIterationCount: "infinite",
        animationTimingFunction: "ease-in-out",
        animationFillMode: "both",
      },
      spinnerDelay1: {
        animationDelay: "0.07s",
      },
      spinnerDelay2: {
        animationDelay: "0.14s",
      },
      spinnerDelay3: {
        animationDelay: "0.21s",
      },
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    isTablet() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg;
    },
    isMobileOrTablet() {
      return this.isMobile || this.isTablet;
    }
  },
  methods: {
    // metodo par cerrar sesion y remover los datos del local store
    logout() {
      localStorage.clear();
      this.$router.push("/");
    },
    showNotification() {
      alert("hola");
    },
    getNotifications() {
      axios
        .get(
          `${
            env.endpoint
          }user/getNotificacionPendientes?idUsuario=${localStorage.getItem(
            "id"
          )}`
        )
        .then((res) => {
          if (res.data.length > 0) {
            this.messages = res.data.length;
            this.notification = true;
            this.notifications = res.data;
          } else {
            this.messages = 0;
            this.notification = false;
            this.notifications = [];
          }
        });
    },
    handleNavigation() {
      if (this.isMobileOrTablet) {
        this.drawer = false;
      }
    },
    onDrawerChange(value) {
      this.drawer = value;
    },
  },
  created() {
    this.getNotifications();
  },

  mounted() {
    setTimeout(() => {
      this.propLoading = false;
    }, 1000);
    setInterval(() => {
      this.getNotifications();
    }, 300000);
  },
};
</script>

<style scoped>
.v-spinner {
  margin-left: 45%;
  margin-top: 250px;
}
@-webkit-keyframes v-syncStretchDelay {
  33% {
    -webkit-transform: translateY(10px);
    transform: translateY(10px);
  }
  66% {
    -webkit-transform: translateY(-10px);
    transform: translateY(-10px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
@keyframes v-syncStretchDelay {
  33% {
    -webkit-transform: translateY(10px);
    transform: translateY(10px);
  }
  66% {
    -webkit-transform: translateY(-10px);
    transform: translateY(-10px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
.drawer {
  z-index: 1000 !important;
}
.close-button-container {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1001;
}
.close-btn {
  background-color: rgba(0, 0, 0, 0.3) !important;
  border-radius: 50%;
}
</style>
